import 'flag-icon-css/css/flag-icon.css'


//////////////////
// WEBPACK FOOTER
// ./~/vue-flag-icon/vendors/index.js
// module id = Meza
// module chunks = 1